export const basepath = process.env.PUBLIC_URL || ''
